import { Controller, useFormContext } from "react-hook-form";
import { View } from "react-native-ui-lib";
import { Label, TextField } from "@towersystems/roam-common-native";
import { useTranslation } from "react-i18next";
import { ApiVaultKeyFormValues } from "../types";

export interface KeyInputFieldProps {}

export const KeyInputField = (props: KeyInputFieldProps) => {
  const { t } = useTranslation("api_key_vault");
  const { control } = useFormContext<ApiVaultKeyFormValues>();
  return (
    <View>
      <Label required label={t("form.vault_key_name.label")}></Label>
      <Controller
        name="key"
        control={control}
        render={({
          field: { onChange, value, onBlur },
          fieldState: { error },
        }) => (
          <TextField
            onBlur={onBlur}
            value={value ?? ""}
            onChangeText={onChange}
            validationMessage={error ? error.message : undefined}
            placeholder={t("form.vault_key_name.placeholder")}
          />
        )}
      />
    </View>
  );
};
